import React, { useEffect, useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
  Text,
  Select,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  capacitacion: any;
}

const ModalInscripciones: React.FC<Props> = ({ isOpen, onClose, capacitacion }) => {
  const [lista, setLista] = useState<any[]>([]);
  const [artesanos, setArtesanos] = useState<any[]>([]);
  const [form, setForm] = useState<any>({
    nombre: '',
    apellidos: '',
    telefono: '',
    correo: '',
    artesanoId: '',
  });
  const [guardando, setGuardando] = useState(false);

  const fetchLista = async () => {
    if (!capacitacion?.id) return;
    try {
      const res = await axiosInstance.get(`/turismo/capacitaciones/${capacitacion.id}/lista`);
      setLista(res.data || []);
    } catch {
      setLista([]);
    }
  };

  const fetchArtesanos = async () => {
    try {
      const res = await axiosInstance.get('/turismo/artesanos');
      setArtesanos(res.data || []);
    } catch {
      setArtesanos([]);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchLista();
      fetchArtesanos();
    }
  }, [isOpen, capacitacion?.id]);

  const handleChange = (field: string, value: any) => {
    setForm((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!form.nombre || !form.apellidos) return;
    setGuardando(true);
    try {
      await axiosInstance.post('/turismo/capacitaciones/inscripciones', {
        capacitacionId: capacitacion.id,
        ...form,
      });
      setForm({ nombre: '', apellidos: '', telefono: '', correo: '', artesanoId: '' });
      fetchLista();
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="xl" overflow="hidden">
        <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">
          Inscripciones - {capacitacion?.nombre}
        </ModalHeader>
        <ModalBody py={5} bg="white">
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel>Nombre</FormLabel>
              <Input value={form.nombre} onChange={(e) => handleChange('nombre', e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Apellidos</FormLabel>
              <Input value={form.apellidos} onChange={(e) => handleChange('apellidos', e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Telefono</FormLabel>
              <Input value={form.telefono} onChange={(e) => handleChange('telefono', e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Correo</FormLabel>
              <Input value={form.correo} onChange={(e) => handleChange('correo', e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Artesano (opcional)</FormLabel>
              <Select value={form.artesanoId} onChange={(e) => handleChange('artesanoId', e.target.value)}>
                <option value="">Sin vincular</option>
                {artesanos.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.nombres} {a.apellidos}
                  </option>
                ))}
              </Select>
            </FormControl>

            <Button bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={handleSubmit} isLoading={guardando} loadingText="Registrando">
              Registrar inscripcion
            </Button>

            <Text fontWeight="bold" mt={4}>Lista de inscritos</Text>
            <Table size="sm">
              <Thead bg="#5b182b">
                <Tr>
                  <Th color="white">Nombre</Th>
                  <Th color="white">Telefono</Th>
                  <Th color="white">Correo</Th>
                </Tr>
              </Thead>
              <Tbody>
                {lista.map((item) => (
                  <Tr key={item.id}>
                    <Td>{item.nombre} {item.apellidos}</Td>
                    <Td>{item.telefono || '-'}</Td>
                    <Td>{item.correo || '-'}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </VStack>
        </ModalBody>
        <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
          <Button onClick={onClose}>Cerrar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalInscripciones;


